import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { renderField } from '../../../../utilities/reduxForm.util'
import { claimActions } from '../../../../redux/actions'

class RadioForm extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: null, selectedResponse: [] }
  }

  handleRadioField = e => {
    const { selectedResponse } = this.state
    const {
      response,
      responseAllowance,
      type,
      question,
      updateSurveyFieldData,
      updateSurveyFieldResponse,
    } = this.props

    let selected
    if (e.target.value) {
      selectedResponse.push(e.target.value)
    }

    // We want to allow multiple radio button selection, `selectedResponse` will contain elements clicked by users
    // Depending on the value of `responseAllowance`, we set `this.state.selected` as an Array or a String
    if (selectedResponse.length > 0) {
      selected =
        selectedResponse.length >= responseAllowance
          ? selectedResponse.slice(-responseAllowance)
          : selectedResponse
    }
    this.setState({ selected }, () => {
      const payloadObject = {}
      const selectedState = this.state.selected

      // Set the string value as the finalResponse
      updateSurveyFieldResponse(selectedState[0], question)

      Object.keys(response).forEach(r => {
        if (selectedState.includes(r)) {
          Object.assign(payloadObject, { [r]: true })
        } else {
          Object.assign(payloadObject, { [r]: false })
        }
      })
      updateSurveyFieldData(payloadObject, type, question)
    })
  }

  render() {
    const { response, onBlur, question } = this.props
    const { selected } = this.state
    return (
      <fieldset aria-labelledby={`survey-radio-label-${question}`}>
        <legend id={`survey-radio-label-${question}`} className="sr-only">
          {question}
        </legend>
        {Object.keys(response).map(item => (
          <Field
            key={item}
            onBlur={onBlur}
            onChange={this.handleRadioField}
            selected={selected}
            name={item}
            component={renderField}
            inputType="radio"
            type="radio"
            value={item}
            label={item}
            aria-checked={selected && selected.includes(item)}
          />
        ))}
      </fieldset>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateSurveyFieldData: (...args) => dispatch(claimActions.updateSurveyFieldData(...args)),
  updateSurveyFieldResponse: (...args) => dispatch(claimActions.updateSurveyFieldResponse(...args)),
})

const connectRadioForm = connect(null, mapDispatchToProps)(RadioForm)

export default reduxForm({ form: 'radioForm' })(connectRadioForm)
